module.exports = __webpack_public_path__ + "static/img/999.94a86bd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/999.png
// module id = we22
// module chunks = 0